var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled from 'styled-components';
import classnames from 'classnames';
import { parseThemePath } from '@axs/axsui-theme';
var Container = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-sizing: border-box;\n  display: ", ";\n  justify-content: ", ";\n  padding: 0;\n\n  .c-axs-tab {\n    box-sizing: border-box;\n    color: ", ";\n    cursor: pointer;\n    border-bottom: ", ";\n    border-left: ", ";\n    display: ", ";\n    padding: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    font-family: ", ";\n    line-height: ", ";\n    text-align: ", ";\n    text-transform: ", ";\n    width: ", ";\n\n    a {\n      text-decoration: none;\n      color: ", ";\n    }\n  }\n\n  .c-axs-tab--active {\n    box-sizing: border-box;\n    background-color: ", ";\n    color: ", ";\n    border-bottom: ", ";\n    border-left: ", ";\n    a {\n      color: ", ";\n    }\n  }\n"], ["\n  box-sizing: border-box;\n  display: ", ";\n  justify-content: ", ";\n  padding: 0;\n\n  .c-axs-tab {\n    box-sizing: border-box;\n    color: ", ";\n    cursor: pointer;\n    border-bottom: ", ";\n    border-left: ", ";\n    display: ", ";\n    padding: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    font-family: ", ";\n    line-height: ", ";\n    text-align: ", ";\n    text-transform: ", ";\n    width: ", ";\n\n    a {\n      text-decoration: none;\n      color: ", ";\n    }\n  }\n\n  .c-axs-tab--active {\n    box-sizing: border-box;\n    background-color: ", ";\n    color: ", ";\n    border-bottom: ", ";\n    border-left: ", ";\n    a {\n      color: ", ";\n    }\n  }\n"])), function (_a) {
    var horizontal = _a.horizontal;
    return (horizontal ? 'flex' : 'block ');
}, function (_a) {
    var fluid = _a.fluid;
    return (fluid ? 'space-between' : 'flex-start');
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return parseThemePath(color, theme, '#0054a1');
}, function (_a) {
    var horizontal = _a.horizontal;
    return horizontal && '5px solid transparent';
}, function (_a) {
    var horizontal = _a.horizontal;
    return (!horizontal ? "5px solid transparent" : 'none');
}, function (_a) {
    var horizontal = _a.horizontal;
    return (horizontal ? 'inline-block' : 'block');
}, function (_a) {
    var horizontal = _a.horizontal;
    return (horizontal ? '8px 16px 6px 16px' : '0 0 0 16px');
}, function (_a) {
    var horizontal = _a.horizontal, fontSize = _a.fontSize;
    return (fontSize ? fontSize : horizontal ? '14px' : '13px');
}, function (_a) {
    var fontWeight = _a.fontWeight, theme = _a.theme;
    return fontWeight ? fontWeight : parseThemePath('axsui.components.menu.fontWeight', theme, 'bold');
}, function (_a) {
    var fontFamily = _a.fontFamily, theme = _a.theme;
    return fontFamily ? fontFamily : parseThemePath('axsui.components.menu.fontFamily', theme, 'Lato');
}, function (_a) {
    var horizontal = _a.horizontal;
    return (!horizontal ? '40px' : 'auto');
}, function (_a) {
    var menuAlign = _a.menuAlign;
    return menuAlign;
}, function (_a) {
    var horizontal = _a.horizontal;
    return (!horizontal ? 'uppercase' : 'inherit');
}, function (_a) {
    var fluid = _a.fluid;
    return (fluid ? '100%' : 'auto');
}, function (_a) {
    var color = _a.color, horizontal = _a.horizontal, theme = _a.theme;
    return horizontal ? parseThemePath(color, theme, '#929292') : parseThemePath(color, theme, '#0054a1');
}, function (_a) {
    var backgroundColorActive = _a.backgroundColorActive, theme = _a.theme;
    return backgroundColorActive
        ? backgroundColorActive
        : parseThemePath('axsui.components.menu.backgroundColorActive', theme, 'transparent');
}, function (_a) {
    var colorActive = _a.colorActive, theme = _a.theme;
    return parseThemePath(colorActive, theme, '#0054a1');
}, function (_a) {
    var horizontal = _a.horizontal, borderColor = _a.borderColor, theme = _a.theme;
    return horizontal ? "5px solid ".concat(parseThemePath(borderColor, theme, '#0054a1')) : 'none';
}, function (_a) {
    var horizontal = _a.horizontal, borderColor = _a.borderColor, theme = _a.theme;
    return !horizontal ? "5px solid ".concat(parseThemePath(borderColor, theme, '#0054a1')) : '#0054a1';
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return parseThemePath(color, theme, '#929292');
});
var AXSMenu = function (props) {
    var newChildren = React.Children.map(props.children, function (child) {
        return React.cloneElement(child, {
            onClick: props.onClick ? props.onClick : function () { return null; },
        });
    });
    return (React.createElement(Container, __assign({ role: "menubar" }, props, { className: classnames(['c-axs-menu', props.className]) }), newChildren));
};
AXSMenu.defaultProps = {
    backgroundColor: 'axsui.components.menu.backgroundColor',
    borderColor: 'axsui.components.menu.borderColor',
    borderColorActive: 'axsui.components.menu.borderColorActive',
    color: 'axsui.components.menu.color',
    colorActive: 'axsui.components.menu.colorActive',
    fluid: false,
    horizontal: false,
    menuAlign: 'left',
};
export { AXSMenu };
var templateObject_1;
